import * as React from "react";
import {AssociatedFeature} from "../domain/AssociatedFeature";

import {connect} from "react-redux";
import AssociationState from "../state/AssociationsState";
import {Definition} from "../domain/Definition";

interface TagProps {}

interface DispatchProps {}

interface StateProps {
    selectedAssociation: AssociatedFeature,
    attributePopoverData: Definition[],
}

type Props = TagProps & StateProps & DispatchProps;

class AssociationInfo extends React.Component<Props, {}> {

    constructor(props: Props) {
        super(props);
    }

    render() {

        let association = this.props.selectedAssociation;
        let associationData = this.props.attributePopoverData;

        if (!association || associationData.length == 0) {
            return null;
        }

        return (
            <div className="associationInfo">
                <h3>{association.descriptiveName} ({association.featureTypeId} - {association.featureType})</h3>
                <dl>
                    {this.props.attributePopoverData.map(entry => {
                        return (
                            <div
                                className={"associationInfoRow"}
                                key={entry.name}
                            >
                                <dt>{entry.name}</dt>
                                <dd>{entry.value}</dd>
                            </div>
                        )
                    })}
                </dl>
            </div>
        )
    }
}

const mapStatToProps = (state: AssociationState) => {
    return {
        selectedAssociation: state.selectedAssociation,
        attributePopoverData: state.attributePopoverData,
    };
};

const mapDispatchToProps = {};

export default connect(mapStatToProps, mapDispatchToProps)(AssociationInfo);
